import { Action } from 'corso-admin-ui';
import { CrewClaimResolutionMethodEnum } from 'corso-types';
import { useState } from 'react';
import useFulfillmentLocations from '~/features/settings/automations/hooks/useFulfillmentLocations';
import { SelectedVariant } from '~/types';
import ExternalResolutionModifier from './ExternalResolutionModifier';
import ProductReplacement from './ProductReplacement';
import { ResolutionModifierProps } from './types';

export default function VariantExchangeModifier({
  claimLineItem,
  onCancel,
  onSave,
}: ResolutionModifierProps<
  typeof CrewClaimResolutionMethodEnum.variantExchange
>) {
  const locations = useFulfillmentLocations();
  const suggestedItem = claimLineItem.suggestedWarrantyReplacementItem
    ? {
        ...claimLineItem.suggestedWarrantyReplacementItem,
        quantity: claimLineItem.quantity,
      }
    : null;

  const currentExchangeItem = claimLineItem.variantExchangeLineItem
    ? ({
        ...claimLineItem.variantExchangeLineItem,
        quantity: claimLineItem.quantity,
        options: claimLineItem.variantExchangeLineItem.options ?? [],
        title: claimLineItem.variantExchangeLineItem.title ?? '',
        grams: claimLineItem.variantExchangeLineItem.grams ?? 0,
        titleWithOptions:
          claimLineItem.variantExchangeLineItem.titleWithOptions ?? '',
        optionsValueString:
          claimLineItem.variantExchangeLineItem.optionsValueString ?? '',
        sku: claimLineItem.variantExchangeLineItem.sku ?? '',
        imgUrl: claimLineItem.variantExchangeLineItem.imgUrl ?? '',
        price: claimLineItem.variantExchangeLineItem.price,
      } satisfies SelectedVariant)
    : null;

  const [variantExchangeLineItem, setVariantExchangeLineItem] =
    useState<SelectedVariant | null>(suggestedItem ?? currentExchangeItem);

  const { name } = claimLineItem.originalStoreOrderLineItem;

  const [wasResolvedExternally, setWasResolvedExternally] = useState(
    !!claimLineItem.wasResolvedExternally,
  );

  return (
    <>
      <ExternalResolutionModifier
        checked={wasResolvedExternally}
        onChange={setWasResolvedExternally}
      />
      <ProductReplacement
        locations={locations.data ?? []}
        defaultSearchTerm={name ?? ''}
        selectedVariants={
          variantExchangeLineItem ? [variantExchangeLineItem] : []
        }
        onChange={(changedReplacementItems) => {
          setVariantExchangeLineItem(changedReplacementItems[0] ?? null);
        }}
        quantityLimit={claimLineItem.quantity}
        variantLimit={1} // only one variant can be selected up to the quantity of the claim line item for a variant exchange
      />

      <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
        <Action variant="ghost" onClick={onCancel}>
          Cancel
        </Action>
        <Action
          variant="primary"
          disabled={!variantExchangeLineItem}
          onClick={() => {
            if (!variantExchangeLineItem) return;
            onSave({
              resolutionMethod: CrewClaimResolutionMethodEnum.variantExchange,
              variantExchangeLineItem,
              wasResolvedExternally,
            });
          }}
        >
          Save
        </Action>
      </div>
    </>
  );
}
